import Title from './Title';
import Content from './Content';
import ContentNew from './ContentNew';

export default {
  Title,
  Content,
  ContentNew,
};
